 /* eslint-disable */
 import React, { Component } from "react"
 import { getUserRole } from "../../redux/actions/action_user"
 import { connect } from 'react-redux'
 import { PropTypes } from 'prop-types'
 import { Redirect } from 'react-router-dom'
 import Loading from "./components/loading"
 import userManager from '../../userManager'
 import logo from "../../images/usbc-single.png"

  class LandingPage extends Component {
 
		constructor(props)
		{
			super(props)
			this.checkRole = this.checkRole.bind(this)
		}  
		checkRole()
		{
			const { oidc } = this.props
			const _this = this
   
			if (oidc.user === null)
			{
				userManager.signinRedirect().then(function(user) {
					_this.props.dispatch(getUserRole())
				})
			}
			else
			{	
				_this.props.dispatch(getUserRole())
			} 
		}

		render() {

			const { 
				roleName,
				roleChecked,
				checkingRole
			} = this.props.user

			// console.log('LandingPage render roleName, roleChecked, checkingRole', roleName, roleChecked, checkingRole)

			if(roleChecked === false)
			{
				 if(checkingRole === false)
				 {
           this.checkRole()
				 }
			}
	  	else
			{
				if(roleName !== "")
				{
				 return (<Redirect to="/dashboard" />)					
				}
				else
				{
					return (<Redirect to="/register" />)
				}
			} 
			return (<div style={{ backgroundImage:logo }} />) 
		}
 }
 LandingPage.propTypes = {
	 dispatch: PropTypes.func
 }
function mapDispatchToProps(dispatch) {
  return ({
    getUserRole
  },dispatch)
}
const mapStateToProps = ({  oidc, user}) => {
	return {
		oidc: { ...oidc },
		user: {...user }
	}
}
 export default connect(mapStateToProps,null)(LandingPage)
 


// WEBPACK FOOTER //
// ./src/containers/landingPage/index.js